import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useCartUIPermissions = () => {
  const { canAccess } = useUser()

  const canEditCart = canAccess(permissionType.CORE_SETUP_CART_EDIT, 0)

  return {
    canEditCart
  }
}
